import React, { ReactNode } from 'react';

import { useFirebaseSync } from './FirebaseProvider.utils';

function FirebaseProvider({ children }: { children?: ReactNode | undefined }): JSX.Element {
	useFirebaseSync();

	return <>{children}</>;
}

export default FirebaseProvider;
